// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import TextInput from '../SimpleFilter/TextInput'
import { addThousandSeparator } from '%/utils/filters/usedVehicles/portalUsedVehiclesV2/makeFiltersPillData';

class KmRange extends Component {
  constructor(props) {
    super(props);

    this.handleKmChange = this.handleKmChange.bind(this);
  }

  handleKmChange(filterKey) {
    return (event) => {
      const value = event.target.value
      const parsedValue = value.replace(/\./g, '')
      
      this.props.handleUpdateFilter(filterKey, parsedValue);
    }
  }

  handleInputChange(event) {
    let value = event.target.value
    value = value.replace(/[^\d.]/g, '')

    const cleanValue = value.replace(/\./g, '')
    const parsedValue = addThousandSeparator(cleanValue)
    
    event.target.value = parsedValue
  }

  render() {
    const { currentMinKm, currentMaxKm } = this.props;

    return ( 
      <div className="advanced-filter__price-range km-range">
        <h4 className="advanced-filter__section-title">Quilometragem</h4>
        <div className="km-range__fields">
        <TextInput
          labelTitle="De"
          name="min_km"
          placeholderText="De"
          value={addThousandSeparator(currentMinKm)}
          handleChange={this.handleKmChange('min_km')}
          handleInputChange={this.handleInputChange}
        />
        <TextInput
          labelTitle="Até"
          name="max_km"
          placeholderText="Até"
          value={addThousandSeparator(currentMaxKm)}
          handleChange={this.handleKmChange('max_km')}
          handleInputChange={this.handleInputChange}
        />
        </div>
      </div>
    );
  }
}

KmRange.defaultProps = {
  currentMinKm: null,
  currentMaxKm: null,
  handleUpdateFilter: () => {},
};

KmRange.propTypes = {
  currentMinKm: PropTypes.number,
  currentMaxKm: PropTypes.number,
  handleUpdateFilter: PropTypes.func,
};

export default KmRange;
